import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EditarConfiguracionProceso from './EditarConfiguracionProceso.jsx';
import * as actions from '../actions/Actions.js';

const mapStateToProps = (state) => {
    return {
        data: state.editarConfiguracionProceso,
        tarjetas: state.tarjetas,

    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(actions, dispatch)
}


//Connect entre el componente y las props y actions.
const EditarConfiguracionProcesoContainer = connect(mapStateToProps, mapDispatchToProps)(EditarConfiguracionProceso);


export default EditarConfiguracionProcesoContainer;